import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

function runInIframe() {
  return window.location !== window.parent.location;
}

ReactDOM.render(
  process.env.REACT_APP_RUN_WITHOUT_FRAME || runInIframe() ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    "The page is not in an iFrame"
  ),
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
